import { useIntl } from 'react-intl';

import { intakeFormUpdateFieldOptions } from '~/actions/intakeForm';
import { useAppConfigContext } from '~/contexts/AppConfig';
import { FormField } from '~/eds/src/components/FormField/FormField';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { Select } from '~/eds/src/components/Select/Select';
import { WorkflowFieldType } from '~/enums/WorkflowFieldType';
import { Nullable } from '~/types/Nullable';

import { Option, SelectCustomSettings } from '../types/fields';
import { WorkflowQuestionFormField } from './types';

export const SelectWorkflowQuestion = ({
  question,
  onChange,
  type,
  ...rest
}: WorkflowQuestionFormField<Nullable<string[]>> & {
  type: WorkflowFieldType.MultiSelect | WorkflowFieldType.SingleSelect;
}) => {
  const { isPanelEnlarged } = useAppConfigContext();
  const intl = useIntl();
  const {
    field: { id: fieldId, value, customSettings },
  } = question;
  const { options = [], enable_create_options: enableCreateOptions } =
    customSettings as SelectCustomSettings;

  const handleAddOption = (newOption: Option) => {
    intakeFormUpdateFieldOptions({
      id: fieldId,
      options: [...options, newOption],
    });
  };

  const emptyValue = type === WorkflowFieldType.MultiSelect ? [] : null;

  return (
    <Layout direction="column" spacing={2}>
      <FormField
        {...rest}
        input={Select}
        value={value.value ?? emptyValue}
        placeholder={
          type === WorkflowFieldType.MultiSelect
            ? intl.formatMessage({
                id: 'SelectWorkflowQuestion.multiSelectPlaceholder',
                defaultMessage: 'Pick one or more options...',
                description:
                  'Placeholder text for a multi select input on the intake form',
              })
            : intl.formatMessage({
                id: 'SelectWorkflowQuestion.singleSelectPlaceholder',
                defaultMessage: 'Pick an option...',
                description:
                  'Placeholder text for a single select input on the intake form',
              })
        }
        onChange={(val: Nullable<string[]>) => onChange(val, 'value')}
        inputProps={{
          options: options || [],
          limit: 100,
          isMulti: type === WorkflowFieldType.MultiSelect,
          onAddOption: enableCreateOptions ? handleAddOption : undefined,
          enablePortal: true,
          width: isPanelEnlarged ? 'input.l.width' : '100%',
        }}
      />
    </Layout>
  );
};
